import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import moment from 'moment-timezone';
import { useContext } from 'react';
import { mapValues } from 'lodash';
import { TimeZoneContext } from '../../shared/context';
import { isTomorrow, isToday } from './date-helpers';
import { TODAY_STRING, TOMORROW_STRING, formatDay } from './date-format-helpers';
export class CentreTime {
  constructor(timeZone) {
    _defineProperty(this, "timeZone", void 0);
    this.timeZone = timeZone;
  }
  assertCentreTime(dt) {
    if (this.timeZone !== dt.tz()) {
      throw new Error('Trying to compare times from two different centre timezones');
    }
    return true;
  }
  fromISOIgnoringOffset(isoString) {
    const OFFSETLESS = 'YYYY-MM-DDTHH:mm:SS';
    const OFFSETFUL = 'YYYY-MM-DDTHH:mm:SSZZ';
    const parsedZone = moment.parseZone(isoString, OFFSETFUL, true);
    const ignoringOffset = parsedZone.isValid() ? parsedZone.format(OFFSETLESS) : isoString;
    return moment.tz(ignoringOffset, this.timeZone);
  }
  fromEntryISO(entry) {
    const {
      showAt,
      hideAt,
      startAt,
      endAt,
      openAt
    } = entry;
    return mapValues({
      showAt,
      hideAt,
      startAt,
      endAt,
      openAt
    }, v => v ? this.fromISOIgnoringOffset(v) : undefined);
    // I'd also like to throw in a mapKeys so the properties have a transformed name
    // e.g. centreShowAt, but not sure how to keep typescript happy.
  }

  formatHumanDay(dt) {
    this.assertCentreTime(dt);
    if (isToday(dt, this.timeZone)) {
      return TODAY_STRING;
    }
    if (isTomorrow(dt, this.timeZone)) {
      return TOMORROW_STRING;
    }
    return formatDay(dt);
  }
}
export default function useCentreTime() {
  const timeZone = useContext(TimeZoneContext);
  if (!timeZone) {
    return null;
  }
  return new CentreTime(timeZone);
}